export default __webpack_public_path__ + "static/media/smart.2a96c206.svg";